// extracted by mini-css-extract-plugin
module.exports = {"button":"custombutton_button__T1__H"};